// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ObW4","header":"ReportDetails_header__34PNw","title":"ReportDetails_title__2lfpH","left":"ReportDetails_left__26mnb"};